// extracted by mini-css-extract-plugin
module.exports = {"main":"UserMenuRender_main__2v74s","dataDiv":"UserMenuRender_dataDiv__3wJTy"};